import { SpiderWebContainer } from '@/components/adg4/spiderweb-container/src/spiderweb-container';
import type {
	WebConnectorConfig,
	WebNodeConfig,
} from '@/components/adg4/spiderweb-container/src/spiderweb-types';

const ambientMovementNodes: WebNodeConfig[] = [
	{
		id: 'square-icon-jpd',
		x: 45.9,
		y: 17.4,
		shape: 'rectangle',
		size: 33,
		bgColor: 'purple400',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9I.svg',
	},
	{
		id: 'square-icon-jira',
		x: 48.4,
		y: 41.6,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9C.svg',
		shape: 'rectangle',
		size: 33,
		bgColor: 'blue700',
	},
	{
		id: 'square-icon-conf',
		x: 77.5,
		y: 50.2,
		shape: 'rectangle',
		size: 33,
		bgColor: 'blue700',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12N5MY.svg',
	},
	{
		id: 'square-icon-loom',
		x: 57,
		y: 64.4,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9D.svg',
		shape: 'rectangle',
		size: 33,
		bgColor: 'blue700',
	},
	{
		id: 'square-icon-talent',
		x: 30.7,
		y: 63.5,
		shape: 'rectangle',
		size: 33,
		bgColor: 'orange300',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9J.svg',
	},
	{
		id: 'square-icon-jsm',
		x: 80,
		y: 90.6,
		shape: 'rectangle',
		size: 33,
		bgColor: 'yellow300',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9E.svg',
	},
	{
		id: 'square-icon-bitbucket',
		x: 86.3,
		y: 39.8,
		shape: 'rectangle',
		size: 33,
		bgColor: 'lime500',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MN9Z.svg',
	},
	{
		id: 'avatar-purple',
		x: 75.5,
		y: 31.4,
		shape: 'circle',
		size: 33,
		bgColor: 'purple500',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVS8.png',
	},
	{
		id: 'avatar-orange',
		x: 55.4,
		y: 50.6,
		shape: 'circle',
		size: 33,
		bgColor: 'orange300',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVSA.png',
	},
	{
		id: 'avatar-yellow',
		x: 73.7,
		y: 70.6,
		shape: 'circle',
		size: 33,
		bgColor: 'yellow300',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVSB.png',
	},
	{
		id: 'avatar-blue',
		x: 25.2,
		y: 73,
		shape: 'circle',
		size: 33,
		bgColor: 'blue700',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVS9.png',
	},
	{
		id: 'square-icon-chatgpt',
		x: 27.8,
		y: 87.1,
		shape: 'rectangle',
		size: 33,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIK.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'art-icon-squiggle',
		x: 43,
		y: 68.3,
		shape: 'rectangle',
		size: 33,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMX.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'square-icon-other',
		x: 87.1,
		y: 78.7,
		shape: 'rectangle',
		size: 33,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA0.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'square-icon-gdrive',
		x: 92,
		y: 30.2,
		shape: 'rectangle',
		size: 33,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA5.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'art-icon-target',
		x: 67,
		y: 79.3,
		shape: 'rectangle',
		size: 33,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMV.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'art-icon-code',
		x: 68.1,
		y: 14.5,
		shape: 'rectangle',
		size: 24,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMS.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'art-icon-lightning',
		x: 69.5,
		y: 37.4,
		shape: 'rectangle',
		size: 24,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMN.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'art-icon-lightbulb',
		x: 68.1,
		y: 62.4,
		shape: 'rectangle',
		size: 24,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMQ.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'art-icon-dollar',
		x: 51.8,
		y: 76.2,
		shape: 'rectangle',
		size: 24,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMZ.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'square-icon-figma',
		x: 49.2,
		y: 60.4,
		shape: 'rectangle',
		size: 24,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MNA4.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'art-icon-video',
		x: 92.3,
		y: 57.8,
		shape: 'rectangle',
		size: 24,
		bgColor: 'neutral1100',
		borderWidth: 1.7,
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12MQMP.svg',
		borderColor: 'neutral700',
	},
	{
		id: 'hex-lime',
		x: 41.2,
		y: 49.5,
		shape: 'hexagon',
		size: 35,
		bgColor: 'lime400',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUII.svg',
	},
	{
		id: 'hex-orange',
		x: 59.3,
		y: 37.3,
		shape: 'hexagon',
		size: 35,
		bgColor: 'orange400',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIH.svg',
	},
	{
		id: 'hex-purple',
		x: 84.8,
		y: 23.2,
		shape: 'hexagon',
		size: 35,
		bgColor: 'purple300',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIG.svg',
	},
	{
		id: 'hex-blue',
		x: 45.2,
		y: 90.2,
		shape: 'hexagon',
		size: 35,
		bgColor: 'blue300',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OUIJ.svg',
	},
	{
		id: 'pill-project',
		x: 57,
		y: 24.8,
		shape: 'rectangle',
		size: 24,
		width: 62,
		bgColor: 'neutral1100',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVRW.svg',
		borderWidth: 1.7,
		borderColor: 'neutral700',
	},
	{
		id: 'pill-work-item',
		x: 67,
		y: 51,
		shape: 'rectangle',
		size: 24,
		width: 72,
		bgColor: 'neutral1100',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OV89.svg',
		borderWidth: 1.7,
		borderColor: 'neutral700',
	},
	{
		id: 'pill-focus-area',
		x: 37,
		y: 79.6,
		shape: 'rectangle',
		size: 24,
		width: 81,
		bgColor: 'neutral1100',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVRU.svg',
		borderWidth: 1.7,
		borderColor: 'neutral700',
	},
	{
		id: 'pill-roadmap',
		x: 83.2,
		y: 66.9,
		shape: 'rectangle',
		size: 24,
		width: 60,
		bgColor: 'neutral1100',
		bgImage: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVRV.svg',
		borderWidth: 1.7,
		borderColor: 'neutral700',
	},
];

const shimmerConnectors: WebConnectorConfig[] = [
	{
		from: 'square-icon-jpd',
		to: 'pill-project',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-jpd',
		to: 'hex-lime',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-jpd',
		to: 'square-icon-jira',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-project',
		to: 'hex-orange',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-work-item',
		to: 'hex-orange',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-work-item',
		to: 'art-icon-lightbulb',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-work-item',
		to: 'art-icon-lightning',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'art-icon-lightning',
		to: 'avatar-purple',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'hex-orange',
		to: 'square-icon-jira',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-jira',
		to: 'hex-lime',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-jira',
		to: 'avatar-orange',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-orange',
		to: 'pill-work-item',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-orange',
		to: 'square-icon-figma',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-orange',
		to: 'square-icon-loom',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'hex-blue',
		to: 'art-icon-dollar',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-loom',
		to: 'art-icon-dollar',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-loom',
		to: 'pill-work-item',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'art-icon-lightbulb',
		to: 'avatar-yellow',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-yellow',
		to: 'pill-roadmap',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-yellow',
		to: 'art-icon-target',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'art-icon-squiggle',
		to: 'art-icon-dollar',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-purple',
		to: 'hex-purple',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'hex-purple',
		to: 'square-icon-bitbucket',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-gdrive',
		to: 'square-icon-bitbucket',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-purple',
		to: 'square-icon-bitbucket',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-work-item',
		to: 'square-icon-conf',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-purple',
		to: 'square-icon-conf',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-bitbucket',
		to: 'square-icon-conf',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'avatar-blue',
		to: 'square-icon-chatgpt',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-roadmap',
		to: 'art-icon-video',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'art-icon-squiggle',
		to: 'pill-focus-area',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-talent',
		to: 'avatar-blue',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-talent',
		to: 'pill-focus-area',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-other',
		to: 'avatar-yellow',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'square-icon-jsm',
		to: 'avatar-yellow',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-focus-area',
		to: 'hex-blue',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-roadmap',
		to: 'pill-work-item',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-project',
		to: 'art-icon-code',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
	{
		from: 'pill-project',
		to: 'avatar-purple',
		isAnimated: true,
		animationEffect: 'shimmer',
	},
];

export const AmbientShimmerGraph = () => (
	<SpiderWebContainer
		nodes={ambientMovementNodes}
		connectors={shimmerConnectors}
		useOnlyExplicitConnectors
		animateOnLoad={false}
		connectorType="dotted"
		ambientMovement
		showAnimationPauseControl
		connectorColor="neutral800"
		bgColor="neutral1100"
		width={1920}
		height={1056}
	/>
);
